// extracted by mini-css-extract-plugin
export default {"leaderboardLink":"B3mIAEVh6CxhbYrSbQYx"};